import { render, staticRenderFns } from "./BillTotalSummary.vue?vue&type=template&id=6874fd1f&scoped=true"
import script from "./BillTotalSummary.vue?vue&type=script&lang=js"
export * from "./BillTotalSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6874fd1f",
  null
  
)

export default component.exports